import { useEffect, useRef } from 'react';
import { isTesting } from '../../common';

export interface UseContractSignPollingOptions {
  onPoll: () => void;
}

export function useContractSignPolling({ onPoll }: UseContractSignPollingOptions) {
  const onPollRef = useRef(onPoll);
  onPollRef.current = onPoll;

  useEffect(() => {
    const intervalId = window.setInterval(
      () => {
        onPollRef.current();
      },
      isTesting ? 200 : 4000
    );

    return () => {
      clearInterval(intervalId);
    };
  }, []);
}
